import React, { FC, useEffect, useState } from 'react'
import ReviewSlider from './ReviewSlider'
import UserInfo from '../../review/UserInfo/UserInfo'
import { getDateString } from '../../../lib/utils'
import Link from 'next/link'
import ArrowIcon from '../../../public/static/icons/arrow-without-stick.svg'
import styles from './ReviewDetail.module.scss'
import { IReview, ISlide } from '../../types'
import Reply from '../../common/Reply'
import { useRouter } from 'next/router'

const ReviewDetailContent: FC<{ review: IReview }> = ({ review }) => {
  const router = useRouter()
  const [initialSlide, setInitialSlide] = useState(null)
  const {
    rate,
    date,
    name,
    text,
    images = [],
    videos = [],
    product,
    reply,
  } = review
  const slides: ISlide[] = [
    ...videos
      ?.filter((v) => v.videoCover?.url && v?.url)
      ?.map((video) => ({
        src: `${process.env.NEXT_PUBLIC_BITRIX_ENDPOINT}${video.url}`,
        id: video.id,
        type: 'video',
        cover: video.videoCover.url,
      })),
    ...images.map((img) => ({
      src: img.url,
      id: img.id,
      type: 'img',
      width: img.width,
      height: img.height,
    })),
  ] as ISlide[]

  useEffect(() => {
    if (router.query.file) {
      const index = slides.findIndex((item) => item.id === router.query.file)

      if (index !== -1) {
        setInitialSlide(index)
      }
    } else {
      setInitialSlide(0)
    }
  }, [])

  return (
    <div className={styles.container}>
      {initialSlide !== null && (
        <ReviewSlider
          className={styles.slider}
          slides={slides}
          initialSlide={initialSlide}
        />
      )}
      <div className={styles.review}>
        <div className={styles.top}>
          <UserInfo
            name={name}
            rate={rate}
            classNames={{
              name: styles.name,
              avatar: styles.avatar,
              container: styles.containerInfo,
              rate: styles.rate,
            }}
          />
          <p className={styles.date}>{getDateString(new Date(date))}</p>
        </div>
        <h3 className={styles.title}>{product.name}</h3>
        {product?.href && (
          <Link href={product.href} passHref>
            <a className={styles.link}>
              Перейти к товару <ArrowIcon />
            </a>
          </Link>
        )}
        <p className={styles.text}>{text}</p>
        {reply && <Reply text={reply} />}
      </div>
    </div>
  )
}

export default ReviewDetailContent
